/** @format */
const variable = {
  primaryColor: '#0091EA',
  borderColor: '#F0F2F4',
  successColor: '#40a54a',
  errorColor: '#FF4433',
  warningColor: '#ff8a00',
  fontColor: '#4c4c4c',
  disableColor: '#bec3c5',
  greyBackground: '#f5f5f5',
  descColor: '#848F9A',
  fontSmall: '12px',
  titleDefault: '14px',
  pagePadding: '197px'
}

export default variable
